import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { hasCookie, setCookie } from 'services/actions/cookies_actions';
import ModalNewRoboLancesImg from 'assets/images/modal/modal-novo-robo-lances.jpg';
import { Container } from 'components/atoms/modal_robo_lances/styles';

const ModalNewRoboLances = () => {
  const [showModal, setShowModal] = useState<boolean>(false);

  useEffect(() => {
    if (!hasCookie('modalNovoRoboLances')) {
      setShowModal(true);
    }
  }, []);

  const handleClose = () => {
    setCookie('modalNovoRoboLances', 'true');
    setShowModal(false);
  };

  return (
    <Modal show={showModal} size="lg" onHide={handleClose} centered>
      <Container>
        <div className="position-relative text-center bg-modal">
          <button
            type="button"
            className="close text-white"
            data-dismiss="modal"
            onClick={handleClose}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <a
            href="https://youtu.be/EGoQbIcDNAs"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleClose}
          >
            <img
              className="card-img-top"
              src={ModalNewRoboLancesImg}
              alt="Novidade no Robô de Lances - Compras.gov"
            />
          </a>
        </div>
      </Container>
    </Modal>
  );
};

export default ModalNewRoboLances;
